import { AutoPopupEntity } from '../../entity/auto-popup.entity';

export class ShowAutoPopupsAction {
  static type = '[AUTO POPUP] Show popups';

  constructor(readonly popups: AutoPopupEntity[]) {}
}
